export default "__VITE_ASSET__ChAUYQ60__"